import React from "react";
import { object, array, string, number, bool } from "prop-types";
import { Link } from "@quintype/components";
import { format } from "date-fns";

import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";

import { getHeadline, getSectionName, getAuthor } from "../../utils/utils";

import "./customStoryCard6.m.css";

const CustomStoryCard6 = ({ story, aspectRatio, imageType, widths, headerType, showStoryTypeIcon, className }) => {
  const headline = getHeadline(story);
  const timeStamp = story["published-at"];
  const authorObj = getAuthor(story);

  return (
    <div styleName="wrapper" className={className}>
      <Link styleName="section-name">
        <span>{getSectionName(story)}</span>
      </Link>

      <div styleName="content">
        <div styleName="left-content">
          <Link href={story.url}>
            <Headline text={headline} headerType={headerType} headerLevel={2} story={story} />
          </Link>

          <div styleName="author-datetime-content">
            <Link href={`/author/${authorObj.id}/${authorObj.slug}`}>{authorObj.name}</Link>
            <span styleName="divider"></span>
            <span>{format(timeStamp, "do MMM ‘yy")}</span>
          </div>
        </div>

        <Link href={story.url}>
          <CardImage
            story={story}
            aspectRatio={aspectRatio}
            imageType={imageType}
            widths={widths}
            eager={true}
            showStoryTypeIcon={showStoryTypeIcon}
          />
        </Link>
      </div>
    </div>
  );
};

CustomStoryCard6.defaultProps = {
  aspectRatio: [5, 4],
  imageType: "image5x4",
  headerType: 3,
  showStoryTypeIcon: true,
  widths: [140],
  className: "",
};

CustomStoryCard6.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  className: string,
  widths: array,
  headerType: number,
  showStoryTypeIcon: bool,
};

export default CustomStoryCard6;
